import React from 'react';
import {Field} from 'redux-form';

import FormField from 'components/FormField';
import Label from 'components/Label';
import {DateField} from 'components/Fields';
import ErrorBlock from 'components/ErrorBlock';

import {validDate} from 'utils/validators';

const BookingPeriodSection = ({
  onStartChange,
  onEndChange,
  startDateGreaterThаnEndDate
}) => (
  <div>
    <FormField>
      <Label>Booking start</Label>
      <Field
        name="startDate"
        component={DateField}
        validate={[validDate]}
        onDateChange={onStartChange}
      />
    </FormField>
    <FormField>
      <Label>Booking end</Label>
      <Field
        name="endDate"
        component={DateField}
        validate={[validDate]}
        onDateChange={onEndChange}
      />
    </FormField>
    {startDateGreaterThаnEndDate && (
      <ErrorBlock>
        {'End date should be greater than or equal to start date'}
      </ErrorBlock>
    )}
  </div>
);

export default BookingPeriodSection;
